import { SET } from "@/stores/CommumActionTypes";

const mutations = {
	[SET]: (state, windTurbine) =>
	{
		state.turbine = windTurbine;
	},
};

export default { mutations };